module.exports = {
  '10': '0.1',
  '20': '0.2',
  '63': '0.63',
  '80': '0.80',
  '85': '0.85',
  '90': '0.90',
  '95': '0.95',
}
